import { badgeColors } from "Consts";

export const defaultObjectSelection = "All current and future objects";

export const severityColors: any = {
  Critical: badgeColors.$red,
  Warning: badgeColors.$yellow,
  Information: badgeColors.$green,
};

export const exportColumns = [
  {
    field: "name",
    name: "Name",
  },
  {
    field: "alertType",
    name: "Alert Type",
  },
  {
    field: "objects",
    name: "Objects",
    render: (objects: any) => {
      return objects.map((i: any) => i.name).join("; ");
    },
  },
  {
    field: "scope",
    name: "Scope",
    render: (resources: any, row: any) => {
      const row_scope = resources?.length > 0 ? resources : row?.profiles;
      return row_scope.map((i: any) => i.name).join("; ");
    },
  },
  {
    field: "ignoreAlert",
    name: "Ignore Alert",
  },
  {
    field: "isEnabled",
    name: "Status",
  },
];

export const newRuleObject = {
  id: null,
  isEnabled: true,
  name: "",
  alertType: "",
  objects: [],
  resources: [],
  profiles: [],
  ignoreAlert: false,
  status: true,

  overrides: {
    isAlertDisabled: false,
    severity: null,
    alertOpenNotificationChannelAssignments: null,
    alertCloseNotificationChannelAssignments: null,
    threshold: {
      thresholdValues: [],
    },
  },
  scope: {
    alertAssignment: null,
    monitoringProfileAssignments: [],
    objectAssignments: [],
    resourceAssignments: [],
  },
};

export const defaultSeverity = "Profile Default";
export const defaultChannel = "Profile Default Channels";
export const noChannel = "No Notifications";

export const ALL: string = "[All]";
export const levelsOptions = [
  {
    label: `${ALL}`,
    value: null,
  },
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
];
